import { Theme } from '@fullcalendar/common'
import CustomDialog from 'common/components/CustomDialog'
import { useMutateUpdateStockPricePerUnit } from 'modules/cost/api/mutation'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Box, InputAdornment, TextField, Typography, useTheme } from '@mui/material'

interface EditPricePerUnitDialogProps {
  open: boolean
  onClose: () => void
  stockId: string
  currentPricePerUnit: number
}

const EditPricePerUnitDialog = ({
  open,
  onClose,
  stockId,
  currentPricePerUnit,
}: EditPricePerUnitDialogProps) => {
  const { t } = useTranslation('cost')
  const [pricePerUnit, setPricePerUnit] = useState(currentPricePerUnit.toString())
  const { mutateAsync, isLoading } = useMutateUpdateStockPricePerUnit()
  const theme = useTheme()

  const handleClose = () => {
    setPricePerUnit(currentPricePerUnit.toString())
    onClose()
  }

  const handleSubmit = async () => {
    const value = parseFloat(pricePerUnit)
    if (isNaN(value)) return
    await mutateAsync({ stockId, price_per_unit: value })
    onClose()
  }

  return (
    <CustomDialog
      open={open}
      closeDialog={handleClose}
      title={t('edit.price.per.unit.title')}
      onSubmit={handleSubmit}
      cancelLabel={t('form.cancel')}
      submitLabel={t('form.save')}
      isSubmitLoading={isLoading}
      disabledSubmit={isNaN(parseFloat(pricePerUnit))}
      enableCloseButton
      maxWidth="sm"
      fullWidth
    >
      <Box sx={{ pt: 1 }}>
        <Typography variant="body2" fontWeight={600} mb={1}>
          <span style={{ color: theme.palette.error.main }}>* </span>
          {t('form.unit.price')}
        </Typography>
        <TextField
          fullWidth
          value={pricePerUnit}
          onChange={(e) => setPricePerUnit(e.target.value)}
          inputProps={{ inputMode: 'decimal' }}
          InputProps={{
            endAdornment: <InputAdornment position="end">{t('unit.baht')}</InputAdornment>,
          }}
        />
        <Box
          sx={{
            mt: 2,
            p: 1.5,
            bgcolor: 'info.lighter',
            borderRadius: 1,
            border: `1px solid ${theme.palette.info.main}`,
          }}
        >
          <Typography variant="body2" color="info.main">
            {t('edit.price.per.unit.note')}
          </Typography>
        </Box>
      </Box>
    </CustomDialog>
  )
}

export default EditPricePerUnitDialog
